import { useEffect, useState } from 'react';
import { Dialog, Button } from '@/design-system';
import * as dashboardApi from '../api/dashboard-api';
import type { Folder, FunnelSummary } from '@/contracts/funnel';

export interface MoveToFolderDialogProps {
  funnel: FunnelSummary | null;
  onClose: () => void;
  onMoved: () => Promise<void>;
}

/** SPEC-003 T050/AC-018: move a funnel to a folder (or remove it from one). */
export function MoveToFolderDialog({ funnel, onClose, onMoved }: MoveToFolderDialogProps) {
  const [folders, setFolders] = useState<Folder[]>([]);
  const [selected, setSelected] = useState<string>('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (funnel) {
      dashboardApi.listFolders().then((res) => setFolders(res.items));
      setSelected(funnel.folder?.id ?? '');
    }
  }, [funnel]);

  async function handleSubmit() {
    if (!funnel) return;
    setSubmitting(true);
    try {
      await dashboardApi.updateFunnel(funnel.id, { folderId: selected || null });
      await onMoved();
      onClose();
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <Dialog open={funnel !== null} onClose={onClose} title="Mover para pasta">
      <div className="flex flex-col gap-4">
        <label className="flex flex-col gap-1 text-sm text-text-secondary">
          Pasta
          <select
            value={selected}
            onChange={(e) => setSelected(e.target.value)}
            className="rounded-md border border-border bg-surface px-3 py-2 text-sm text-text-primary"
          >
            <option value="">Sem pasta</option>
            {folders.map((folder) => (
              <option key={folder.id} value={folder.id}>
                {folder.name}
              </option>
            ))}
          </select>
        </label>
        <div className="flex justify-end gap-2">
          <Button type="button" variant="secondary" onClick={onClose} disabled={submitting}>
            Cancelar
          </Button>
          <Button type="button" onClick={handleSubmit} disabled={submitting}>
            {submitting ? 'Movendo…' : 'Mover'}
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
